﻿// @ts-nocheck
// logout, timezone, timer helpers

async function logout() {
  // Kill server session and reload.
  try {
    await fetch("/api/auth/logout", { method: "POST", credentials: "same-origin" });
  } catch (_) { /* ignore */ }
  window.location.href = "/";
}

function saveTimezone() {
  const select = document.getElementById("timezoneSelect");
  userTimezone = select.value;
  localStorage.setItem("userTimezone", userTimezone);
}

function loadTimezone() {
  const select = document.getElementById("timezoneSelect");
  if (select) {
    select.value = userTimezone;
  }
}
function formatTimer(ms) {
  const secs = Math.floor(ms / 1000);
  const h = String(Math.floor(secs / 3600)).padStart(2, "0");
  const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
  const s = String(secs % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
}

function updateTimer() {
  const timerEl = document.getElementById("timer");
  if (!currentSession || !currentSession.startTime) return;
  const elapsed = Date.now() - currentSession.startTime;
  timerEl.textContent = formatTimer(elapsed);
}

function stopLocalTimer() {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  const timerEl = document.getElementById("timer");
  timerEl.textContent = "00:00:00";
}
